
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import { LearningProgress } from '@/const/LearningProgress'

/**
 * 学習進捗状況表示チップ
 */
@Component({
  components: {
    ImageBase,
  },
})
export default class LearningProgressTip extends Vue {
  /** 学習進捗状況 */
  @Prop()
  learningProgress!: LearningProgress.LearningProgressMaster

  /**
   * 完了済かの判定
   *
   * @returns 完了済ならtrue
   */
  private get isCompleted(): boolean {
    return this.learningProgress === LearningProgress.COMPLETE
  }

  /**
   * 学習進捗状況の色指定
   *
   * @returns css指定
   */
  private get setStyle(): { [key: string]: string } {
    return {
      '--color-learning-progress__text': `var(${this.learningProgress.color})`,
      '--color-learning-progress__background': `var(${this.learningProgress.colorBackGround})`,
    }
  }
}
